import React from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';

import { Grid, Link, Typography } from '@material-ui/core';

// Icons (see https://material-ui.com/components/material-icons/)
import {
  AccountCircle as AccountCircleIcon,
  Email as EmailIcon,
  Lock as LockIcon,
} from '@material-ui/icons';

import { yupResolver } from '@hookform/resolvers';

import { useForm } from 'react-hook-form';

import { schemaSignup } from '../../_schema';
import { AmFormButton, AMTextField } from '../../controls';
import { appStyles } from '../../_styles';

const SignUp = () => {
  const classes = appStyles();

  // Use Hook to get history instead of via param.history
  const history = useHistory();

  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(schemaSignup),
  });

  /**
   *
   * @param {*} login Login object from form. Object has allready been verified
   *                  by form. See schemaLogin for object properties.
   */
  const onSubmit = (login: any) => {
    history.push('/');
  };

  return (
    <div>
      <AccountCircleIcon color="action" style={{ fontSize: 140 }} />
      <Typography variant="h4" component="h1" color="textSecondary">
        Sign up
      </Typography>
      <Typography variant="body1" component="h1" color="textSecondary">
        ACTMT is in very early stages of development. Thank you for being an
        early adopter. An email address is not required but useful if you forget
        your password.
      </Typography>

      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <AMTextField
          name="email"
          control={control}
          errors={errors}
          schema={schemaSignup}
          icon={EmailIcon}
        />

        <AMTextField
          name="userName"
          control={control}
          errors={errors}
          schema={schemaSignup}
          icon={AccountCircleIcon}
        />

        <AMTextField
          name="password"
          control={control}
          errors={errors}
          schema={schemaSignup}
          icon={LockIcon}
          type="password"
        />

        <AmFormButton>Create Account</AmFormButton>

        <Grid container direction="row" justify="center">
          <Grid item>
            <Link component={RouterLink} to="/privacy-policy" variant="body2">
              Privacy Policy
            </Link>
          </Grid>
          <Grid item>&nbsp;</Grid>
          <Grid item>
            <Link component={RouterLink} to="/tos" variant="body2">
              Terms of Service
            </Link>
          </Grid>
        </Grid>

        <Link component={RouterLink} to="/sign-in" variant="body2">
          {'Return to login'}
        </Link>
      </form>
    </div>
  );
};

export { SignUp };
